import React, { Fragment, useEffect, useRef, useState } from "react";

import "@/styles/dashboard/comments.scss";
import CardComponent from "@/components/card";
import BackWithLabel from "@/components/common/BackWithLabel";
import Container from "@/components/container/Container";
import { Col, Flex, Input, Row } from "antd";
import IconSent from "@/components/icons/IconSent";
import IconAttachment from "@/components/icons/IconAttachment";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTaskById as getStudentTask } from "@/services/students/getTaskById";
import ButtonComponent from "@/components/button/Button";
import { submitStudentTaskDocumentById } from "@/services/students/submitStudentTaskDocumentById";
import { addCommentToTasks } from "@/services/students/addCommentToTasks";
import { getCommentsFromTaskId } from "@/services/students/getCommentsFromTaskId";
import { uploadFile } from "@/services/users/uploadFile";
import { getFormatedFileByCategory } from "@/services/users/getFormatedFileByCategory";
import moment from "moment";
import { openLinkInNewTab } from "@/helpers";
import { getIsGuidePanel } from "@/reducers/guideSlice";
import { markTaskAsComplete } from "@/services/guides/getGuideTasks";

const Comments = () => {
  const dispatch = useDispatch();
  const [taskData, setTaskData] = useState({});
  const [commentData, setCommentData] = useState([]);
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const isGuidePanel = useSelector(getIsGuidePanel);

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Process the uploaded file here
      const formData = new FormData();
      formData.append("file", file);
      uploadFile(-1, formData)
        .then((res) => {
          addCommentToTasks(id, { fileKey: res.fileKey })
            .then((res) => {
              fileInputRef.current.value = null;
              fetchCommentData();
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    }
  };

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  const fetchCommentData = () => {
    getCommentsFromTaskId(id)
      .then((res) => {
        const comments = res.map((x) => {
          return {
            body: x.body.filter((f) => Object.keys(f)?.length)[0],
            createdAt: x.createdAt,
            userId: x.userId,
          };
        });
        const formatedComment = comments.map((x) => {
          const isDataAvialable = Object.keys(x.body)?.length;
          if (isDataAvialable) {
            const key = Object.keys(x.body).includes("file");
            return {
              type: key ? "file" : "text",
              data: x.body[key ? "file" : "text"],
              timeStamp: moment(x.createdAt).format("lll"),
              user: x.userId.isCurrentUser ? "@you" : x.userId.name,
              userId: x.userId,
            };
          } else {
            return null;
          }
        });
        setCommentData(formatedComment.filter((x) => x));
      })
      .catch((err) => console.log(err));
  };

  const fetchData = async () => {
    getStudentTask(id)
      .then(async (taskResponse) => {
        const fileData = await getFormatedFileByCategory();
        const matchedFile = fileData.find((x) => x.id === taskResponse?.fileCategoryId);

        const deadlineDate = taskResponse.deadline ? new Date(taskResponse.deadline) : null;
        const isOverdue = deadlineDate && deadlineDate < new Date();

        const data = {
          ...taskResponse,
          totalLimit: matchedFile?.limit,
          currentLimit: matchedFile?.limit - matchedFile?.files?.length,
          displayStatus: taskResponse.closedAt
            ? "Completed"
            : taskResponse.completedAt
              ? "Submitted"
              : isOverdue
                ? "Overdue"
                : "To Do",
          deadline: deadlineDate
            ? deadlineDate.toLocaleDateString("en-GB", {
                weekday: "long",
                day: "numeric",
                month: "short",
              })
            : "No deadline",
        };
        setTaskData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
    fetchCommentData();
  }, [id]);

  // To submit task
  const handleSubmit = (id, limit, item) => {
    dispatch(setCurrentForm("dashboardDocChat"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        onSubmit: (value) => {
          const files = [];
          if (value?.file?.fileList?.length > 0) {
            const uploadPromises = value.file?.fileList?.map(async (fileItem) => {
              const formData = new FormData();
              formData.append("file", fileItem.originFileObj);

              return uploadFile(-1, formData)
                .then((res) => {
                  files.push(res);
                })
                .catch((err) => {
                  console.error(err);
                });
            });

            Promise.all(uploadPromises).then(() => {
              // const finalFormData = new FormData();
              // console.log(files, "files");
              // finalFormData.append("comment", value.documentName ?? "");
              // finalFormData.append("files", JSON.stringify(files));
              const body = {
                comment: value.comment ?? "",
                files: files,
              };
              submitStudentTaskDocumentById(id, body)
                .then((res) => {
                  fetchData();
                  dispatch(setModalOpen(false));
                })
                .catch((err) => console.log(err));
            });
          } else {
            submitStudentTaskDocumentById(id, value)
              .then((res) => {
                dispatch(setModalOpen(false));
                fetchData();
              })
              .catch((error) => console.log(error));
          }
          // const file = value.file?.fileList[0]?.originFileObj;
          // const comment = value.comment;
          // const formData = new FormData();
          // formData.append("file", file);
          // formData.append("comment", comment);
        },
        limit: limit,
        isComment: !item.fileCategoryId,
      })
    );
  };

  // To add Comment

  const handleAddComment = () => {
    let body = {
      text: message,
    };
    addCommentToTasks(id, body)
      .then((res) => {
        console.log(res);
        setMessage("");
        fetchCommentData();
      })
      .catch((err) => console.log(err));
  };

  const isOwnTask = (item) => {
    return item.userId === item.assignedBy?.id;
  };

  const isButtonDisabled = (item, isGuidePanel) => {
    console.log(isGuidePanel);
    if (isGuidePanel) {
      if (isOwnTask(item)) {
        if (item.status !== "todo") {
          return true;
        }
      } else if (!item.completedAt || item.closedAt) {
        return true;
      }
    } else {
      if (item.status !== "todo") {
        return true;
      }
    }
    return false;
  };
  const getTaskLabel = (item) => {
    if (isOwnTask(item)) {
      return item.status === "todo" ? "Complete Task" : "Completed";
    }

    if (isGuidePanel) {
      return item.status === "completed" ? "Completed" : "Mark as Completed";
    }

    return item.status === "todo" ? "Submit Task" : "Submitted";
  };

  const handleGuideSubmit = (item) => {
    const id = item.id;
    const limit = item.currentLimit;
    console.log(limit);
    if (item.status === "submitted") {
      dispatch(setCurrentForm("confirmDelete"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          message: "Mark this task as completed?",
          onSubmit: () => {
            markTaskAsComplete(id).then((res) => {
              dispatch(setModalOpen(false));
              fetchData();
            });
          },
        })
      );
    } else {
      handleSubmit(id, limit, item);
    }
  };

  const UserProfileComp = ({ userData }) => {
    return (
      <div
        style={{
          borderRadius: "50%",
          height: "20px",
          width: "20px",
        }}
      >
        <img
          src={userData.profileImgUrl || "/assets/images/defaultProfile.jpeg"}
          alt="profile"
          width={"100%"}
          height={"100%"}
          style={{
            borderRadius: "50%",
          }}
        />
      </div>
    );
  };

  return (
    <Fragment>
      <div className="comments-wrapper">
        <Container>
          <div className="comments-header">
            <BackWithLabel path="/dashboard/tasks" label="Comments" />
          </div>
          <div className="comment-conversation">
            <CardComponent>
              <div className="comment-conversation-card">
                <Flex className="comment-conversation-header" vertical gap={"1rem"}>
                  <CardComponent>
                    <div className="comment-title">
                      {taskData.title}: {taskData.description}
                    </div>
                    {/* <div className="comment-status">
                      <Form.Item label="Task State:" name="assign-menu">
                        <Select
                virtual={false}
                          showSearch
                          placeholder="Select Status"
                          style={{ width: "25%" }}
                        >
                          <Option className="assign-menu" value="assign-to-you">
                            Overdue
                          </Option>
                        </Select>
                      </Form.Item>
                    </div> */}
                    <Row gutter={[16, 16]}>
                      <Col sm={24} md={12} lg={12}>
                        <Flex gap={"10px"}>
                          <div className="body-b3">Status:</div>
                          {taskData.displayStatus === "Overdue" ? (
                            <div style={{ color: "#E9635E" }}>{taskData.displayStatus}</div>
                          ) : (
                            <div>{taskData.displayStatus}</div>
                          )}
                        </Flex>

                        <div className="deadline body-b4">
                          <span className="label">Deadline:</span>&nbsp;&nbsp;
                          <span className="date">{taskData.deadline}</span>
                        </div>
                      </Col>
                      <Col sm={24} md={12} lg={12}>
                        <Flex justify="end">
                          <ButtonComponent
                            label={getTaskLabel(taskData, isGuidePanel)}
                            disabled={isButtonDisabled(taskData, isGuidePanel)}
                            size="medium"
                            varient="success"
                            onClick={() => {
                              isGuidePanel
                                ? handleGuideSubmit(taskData, taskData.currentLimit)
                                : handleSubmit(id, taskData.currentLimit, taskData);
                            }}
                          />
                        </Flex>
                      </Col>
                    </Row>
                  </CardComponent>

                  <div className="body-b3">Comments:</div>
                  <div className="conversation-content">
                    <div className="chat-container">
                      {commentData.map((chat, i) => {
                        if (chat.type == "file") {
                          return (
                            <Flex gap={"5px"} key={i}>
                              <UserProfileComp userData={chat.userId} />
                              <CardComponent
                                className="chat-card document"
                                onClick={() => openLinkInNewTab(chat.data)}
                              >
                                <div className="container">
                                  <span className="author">{chat.user}</span>
                                  <div>
                                    <img
                                      src="/assets/images/docs.png"
                                      alt="document"
                                      width={30}
                                      height={30}
                                    />
                                  </div>
                                  <span className="stamp">{chat.timeStamp}</span>
                                </div>
                              </CardComponent>
                            </Flex>
                          );
                        } else {
                          return (
                            <Flex gap={"5px"} style={{ maxWidth: "100%" }} key={i}>
                              <UserProfileComp userData={chat.userId} />
                              <CardComponent className="chat-card you-card">
                                <span className="author">{chat.user}</span>
                                <div className="comment-msg">{chat.data}</div>
                                <span className="stamp">{chat.timeStamp}</span>
                              </CardComponent>
                            </Flex>
                          );
                        }
                      })}
                    </div>
                  </div>

                  <Flex className="conversation-input" gap={"1rem"}>
                    <div className="input-container" style={{ overflow: "hidden" }}>
                      {/* <div className="emoji-icon">
                        <IconEmoji width={30} height={30} color="#000" />
                      </div> */}
                      <div className="input">
                        <Input
                          name="message"
                          value={message}
                          onChange={handleChange}
                          placeholder="Type your message here..."
                          style={{ height: 56, resize: "none", width: "100%" }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              if (message?.trim()) {
                                handleAddComment();
                              }
                            }
                          }}
                        />
                      </div>
                      <div
                        className="upload-icon"
                        // onClick={handleUploadCommentFile}
                      >
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          multiple="false"
                        />

                        <IconAttachment
                          width={30}
                          height={30}
                          color="#000"
                          onClick={handleButtonClick}
                        />
                      </div>
                    </div>

                    <div className="send-button">
                      <div
                        className="send-button-box"
                        style={{
                          opacity: message?.length ? 1 : 0.5,
                          cursor: message?.length ? "pointer" : "not-allowed",
                        }}
                      >
                        <IconSent
                          width={30}
                          height={30}
                          color="#fdfefe"
                          onClick={message?.length ? () => handleAddComment() : () => {}}
                        />
                      </div>
                    </div>
                  </Flex>
                </Flex>
              </div>
            </CardComponent>
          </div>
        </Container>
      </div>
    </Fragment>
  );
};

export default Comments;
